import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { facilitatorService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'facilitator',
  initialState: adapter.getInitialState({
    busy: false,
    facilitatorCsvExtract: [],
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setFacilitatorCsvExtract: (state, { payload }) => ({ ...state, facilitatorCsvExtract: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchFacilitatorLog = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await facilitatorService.fetchFacilitatorLog(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchFacilitatorCsvExtract = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await facilitatorService.fetchFacilitatorLog(params);
    dispatch(slice.actions.setFacilitatorCsvExtract(resData));
    dispatch(slice.actions.setBusy(false));
    return resData;
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchFacilitatorLog,
  fetchFacilitatorCsvExtract,
};

const selectors = {
  ...adapter.getSelectors((state) => state.finance),
};

export { actions, selectors };

export default slice.reducer;
